import styled from 'styled-components';

export const TooltipParagraph = styled.div`
  & + & {
    margin-top: 18px;
  }
`;
